import { useStaticQuery, graphql } from 'gatsby';
import useTransformMenus from './use-transform-menus';

const useMenuItems = () => {
  const { strapiMenus } = useStaticQuery(graphql`
    query UseStrapiMenusUseFooterMenuItems {
      strapiMenus: allStrapiMenusMenus(
        sort: { priority: ASC }
        filter: {
          position: {
            eq: "Footer"
          }
        }
      ) {
        nodes {
          id
          title
          position
          items {
            ...MenuMenuItems
          }
        }
      }
    }
  `);
  const menus = useTransformMenus(strapiMenus);

  return {
    menuItems: menus[0]?.items,
    menus,
  };
};

export default useMenuItems;
